import dynamic from 'next/dynamic';
import { AddToCartTastic } from './add-to-cart';
import { HeaderTastic } from './header';
import { NotFoundTastic } from './not-found';
import { DynamicOrderHistoryTastic, OrderHistoryTastic } from './order-history';
import { RedeemDiscountTastic } from './redeem-discount';
import { ThankYouTastic } from './thank-you';
import { TasticRegistry } from './types';

const CheckoutTastic = dynamic(() => import('./checkout'));

export const tastics = {
  'ui/add-to-cart': AddToCartTastic,
  'ui/checkout': CheckoutTastic,
  'ui/header': HeaderTastic,
  'ui/not-found': NotFoundTastic,
  'ui/thank-you': ThankYouTastic,
  'ui/order-history': OrderHistoryTastic,
  'ui/order-history-via-dynamic': DynamicOrderHistoryTastic,
  'ui/redeem-discount': RedeemDiscountTastic,
} as TasticRegistry;
